// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bbeab18a","453":"2f02323f","732":"94191313","977":"806bbd4a"}[chunkId] + ".chunk.js";
};